/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentSchedulesDeleteAgentSchedule } from "../../funcs/agentSchedulesDeleteAgentSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteAgentScheduleRequest$inboundSchema,
};

export const tool$agentSchedulesDeleteAgentSchedule: ToolDefinition<
  typeof args
> = {
  name: "agent-schedules-delete-agent-schedule",
  description: `Delete an agent schedule`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentSchedulesDeleteAgentSchedule(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
